import { useState } from 'react';
import styled from 'styled-components';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Refresh24 } from 'ui/icons';
import { ModalFooter } from 'ui/modal';
import { colors } from 'ui/theme';

const RetestConfirmationLabel = styled.p`
  color: ${colors.textSecondary};

  strong {
    color:  ${colors.textPrimary};
  }
  `;

export const spamReportModalFooterText = {
  retestButtonLabel: 'Regenerate report',
  cancelButtonLabel: 'Cancel',
  confirmButtonLabel: 'Confirm',
  retestDescriptionPrimary: 'Regenerate spam report?',
  retestDescriptionSecondary:
    'Most filters should be finished in 20 minutes, but on rare occasions, a few may take up to 2 hours.',
};

export const RETEST_CONFIRMATION_LABEL_TEST_ID = 'spam-report-retest-confirmation-label';
export const RETEST_BUTTON_TEST_ID = 'spam-report-retest-button';
export const CANCEL_BUTTON_TEST_ID = 'spam-report-cancel-button';
export const CONFIRM_RETEST_BUTTON_TEST_ID = 'spam-report-confirm-retest-button';

interface SpamReportFooterProps {
  handleCloseModal: () => void;
  handleRetestAction: () => void;
}

export const SpamReportFooter = ({
  handleRetestAction,
  handleCloseModal,
}: SpamReportFooterProps) => {
  const [isConfirmRetest, setIsConfirmRetest] = useState(false);
  return (
    <ModalFooter
      hasCancel={false}
      message={
        isConfirmRetest ? (
          <RetestConfirmationLabel data-test={RETEST_CONFIRMATION_LABEL_TEST_ID}>
            <strong>{spamReportModalFooterText.retestDescriptionPrimary}</strong>{' '}
            {spamReportModalFooterText.retestDescriptionSecondary}
          </RetestConfirmationLabel>
        ) : null
      }
    >
      {!isConfirmRetest && (
        <Button
          data-test={RETEST_BUTTON_TEST_ID}
          type="button"
          variant={BUTTON_VARIANTS.GHOST}
          size={BUTTON_SIZES.LARGE}
          onClick={() => setIsConfirmRetest(true)}
        >
          <Refresh24 />
          {spamReportModalFooterText.retestButtonLabel}
        </Button>
      )}

      <Button
        data-test={CANCEL_BUTTON_TEST_ID}
        type="button"
        variant={BUTTON_VARIANTS.GHOST}
        size={BUTTON_SIZES.LARGE}
        onClick={isConfirmRetest ? () => setIsConfirmRetest(false) : handleCloseModal}
      >
        {spamReportModalFooterText.cancelButtonLabel}
      </Button>

      {isConfirmRetest && (
        <Button
          data-test={CONFIRM_RETEST_BUTTON_TEST_ID}
          type="button"
          variant={BUTTON_VARIANTS.PRIMARY}
          size={BUTTON_SIZES.LARGE}
          onClick={() => {
            handleRetestAction();
            setIsConfirmRetest(false);
          }}
        >
          {spamReportModalFooterText.confirmButtonLabel}
        </Button>
      )}
    </ModalFooter>
  );
};
